import { SharedLocale } from "../schema/SharedLocale.js";

export function sameValueForEverySharedLocale<T>(value: T): Record<SharedLocale, T> {
	return Object.fromEntries(Object.values(SharedLocale).map((locale) => [locale, value])) as Record<SharedLocale, T>;
}
